import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-edit-profile",
    templateUrl: "./edit-profile.component.html",
    styleUrls: ["./edit-profile.component.scss"],
})
export class EditProfileComponent implements OnInit {
    file: File = null; // Variable to store file

    constructor() {}

    ngOnInit(): void {}

    onChange(event) {
        this.file = event.target.files[0];
    }
}
